import IntegrationTwo from "../LandingPage/integrationTwo";
import HeroSection from "./HeroSection";
import LandingSectionThree from "./LandingSectionThree";
import NavigationBar from "./NavigationBar";
import ScalingTeam from "./ScalingTeam";
import landingPageData from "../../constants/data.json";
import { Testimonials } from "./testimonials";
import Contact from "./Contact";
import DemoSection from "../../components/DemoSection";

const NewLandingPage = () => {
  return (
    <>
      <NavigationBar />
      <HeroSection />
      <IntegrationTwo />
      <ScalingTeam />
      <LandingSectionThree />
      <DemoSection />
      <Testimonials data={landingPageData.Testimonials} />
      <Contact />
    </>
  );
};
export default NewLandingPage;
